module.exports = __webpack_public_path__ + "img/comment-empty@2x.4f372b44.png";